module.exports = __webpack_public_path__ + "img/TopBar.9ec2ac0a.png";